/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Rosy_Panda_CookInputs */

const en_soft_rosy_panda_cook = /** @type {(inputs: Soft_Rosy_Panda_CookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove user`)
};

const de_soft_rosy_panda_cook = /** @type {(inputs: Soft_Rosy_Panda_CookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer entfernen`)
};

/**
* | output |
* | --- |
* | "Remove user" |
*
* @param {Soft_Rosy_Panda_CookInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const soft_rosy_panda_cook = /** @type {((inputs?: Soft_Rosy_Panda_CookInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Rosy_Panda_CookInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_soft_rosy_panda_cook(inputs)
	return de_soft_rosy_panda_cook(inputs)
});